import { API_PREFIX } from "./api.constants";

export const TENANT_ENDPOINTS = {
  TENANTS:              `${API_PREFIX}/tenants/`,
  TENANT_DETAIL:        (tenantId: number | string) => `${API_PREFIX}/tenants/${tenantId}`,
  TENANT_DELETE_IMPACT: (tenantId: number | string) => `${API_PREFIX}/tenants/${tenantId}/delete-impact`,
  TENANTS_EXPORT:       `${API_PREFIX}/tenants/export`,
  TENANTS_USAGE:        `${API_PREFIX}/tenants/usage-per-tenant`,
  TENANT_BRANDING_CURRENT: `${API_PREFIX}/tenants/branding/`,
  TENANT_BRANDING_DETAIL:  (tenantId: number | string) => `${API_PREFIX}/tenants/${tenantId}/branding/`,
  TENANT_EXPLORE_COVER:    `${API_PREFIX}/tenants/branding/explore-cover`,
  TENANT_EXPLORE_SETTINGS: `${API_PREFIX}/tenants/branding/explore-settings`,
  TENANT_COMMUNITIES_COVER: `${API_PREFIX}/tenants/branding/communities-cover`,
  SWITCH_TENANT:        (targetTenantId: number | string) => `${API_PREFIX}/auth/switch-tenant/${targetTenantId}`,
  MY_TENANTS:           `${API_PREFIX}/users/me/tenants`,
  TENANT_SET_DEFAULT:   (tenantId: number | string) => `${API_PREFIX}/tenants/${tenantId}/set-default`,
  TENANT_UNSET_DEFAULT: (tenantId: number | string) => `${API_PREFIX}/tenants/${tenantId}/unset-default`,
  TENANT_ASSIGN_USERS:  (tenantId: number | string) => `${API_PREFIX}/tenants/${tenantId}/assign-users`,
  TENANT_MEMBERS:       (tenantId: number | string) => `${API_PREFIX}/tenants/${tenantId}/members`,
  TENANT_MEMBER_DETAIL: (tenantId: number | string, userId: number | string) => `${API_PREFIX}/tenants/${tenantId}/members/${userId}`,
};